import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setUser } from "../slices/userSlice";
import { admin } from "../api/axios";
import {
  isClientSsoAuthSession,
  isClientSsoHandshakePath,
} from "../../constants/clientSso";

export function useLoadingWithRefresh() {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    (async () => {
      if (isClientSsoHandshakePath()) {
        setLoading(false);
        return;
      }
      try {
        const path = isClientSsoAuthSession() ? "client-sso/me" : "auth/me";
        const { data } = await admin.get(path);
        const payload = data.data;
        dispatch(
          setUser(
            isClientSsoAuthSession()
              ? {
                  name: payload.name,
                  email: payload.email,
                  emailVerified: true,
                  group: payload.group,
                  userId: payload.userId,
                }
              : payload
          )
        );
        setLoading(false);
      } catch (err) {
        setLoading(false);
      }
    })();
  }, [dispatch]);

  return { loading };
}
